import { render } from "./ShowListStatistical.vue?vue&type=template&id=39f9258b&ts=true"
import script from "./ShowListStatistical.vue?vue&type=script&lang=ts"
export * from "./ShowListStatistical.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__